
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vlozeni-inzeratu/formular/typ-inzerce",
      function () {
        return require("private-next-pages/vlozeni-inzeratu/formular/typ-inzerce.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vlozeni-inzeratu/formular/typ-inzerce"])
      });
    }
  